export { default } from './InstagramProductSlider';
